<template>
  <div class="deep-dive-report">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <deep-dive-tab @clickedTab="selectedTab"></deep-dive-tab>
      <report-filter-bar @selectedGroupObj="setGroupCourseObj" @selectedCohortObj="setCohortObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag"></report-filter-bar>
      <hr width="94%" size="10px">
      <div class="row margin-Top-2Perc">
        <div class="col-md-12 col-lg-12 width-97Point4 margin-left-1point5Perc">
          <sortable-list v-if="showDeepDiveList" v-bind:responseObj="getDeepDiveRespArrResp" v-bind:sortableColumnName="sortColumnNames" v-bind:columnNameToShow="columnNameToShow" v-bind:linkColumnName="linkColumnNames" v-bind:selectedsubOption="7"></sortable-list>
        </div>
      </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
    </div>
    <loader></loader>
    <error-page v-if="isUserGroupAdmin"></error-page>   
  </div> 
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import csvHelper from '@/utils/csv-helper'
import { reportService } from '@/server-util/report-service'
import ReportFilterBar from '@/components/ReportFilterBar'
import { trackerService } from '@/server-util/tracker-service'
import { constants } from '@/utils/constants'
import CopyrightElement from '@/components/CopyrightElement'
import DeepDiveTab from '@/components/DeepDiveTab'
import list from '@/pages/SortableList'
import AlertBox from '@/components/AlertOverlay'
import ErrorPage from '@/pages/Error'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.bindColumnsNameAndAlias()
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      selectedGroupObj: null,
      selectedCohortObj: null,
      showExportButton: true,
      errorMsg: '',
      showSpinner: false,
      showAlertDialog: false,
      deepDiveRespArr: [],
      showDeepDiveList: false,
      sortColumnNames: ['Participant', 'VideosWatched', 'TotalVideos', 'AvgDeepDiveViews'],
      columnAlias: ['Participant', 'Videos Watched', 'Total Videos', '% Views'],
      columnRespKey: ['Participant', 'VideosWatched', 'TotalVideos', 'AvgDeepDiveViews'],
      columnNameToShow: [],
      linkColumnNames: ['Comments', 'Likes'],
      isExportBtnClicked: false,
      isViewBtnClicked: false,
      csvFileName: 'DeepDiveParticipantReport',
      currentSelectedTab: 1
    }
  },
  components: {
    'report-filter-bar': ReportFilterBar,
    'deep-dive-tab': DeepDiveTab,
    'Copyright-Element': CopyrightElement,
    'sortable-list': list,
    'alert-box': AlertBox,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    trackPageLoad () {
      var store = this.$store
      var accessToken = store.state.access_token
      var userData = store.state.curr_user
      var userDataForActivity = 'UserName:{0}, FullName: {1}'
      userDataForActivity = userDataForActivity.replace('{0}', userData.UserName)
      userDataForActivity = userDataForActivity.replace('{1}', userData.FirstName + ' ' + userData.LastName)
      var trackingObj = {
        ActivityData: 'Load Discussions Page, ' + userDataForActivity,
        ActivityType: constants.AdminActivityType.Discussions,
        AdminAction: constants.AdminActionType.LoadScreen,
        ScreenName: 'DISCUSSIONS',
        UserRole: store.state.curr_user.AccountType,
        IsPrivate: false
      }
      trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
        if (responseObj3.status === 200) {
          console.log('LOGGED ACTIVITY : ')
        }
      })
    },
    selectedTab (value) {
      // AK: Hide list when user selects different option than current
      if (this.currentSelectedTab !== value) {
        this.isExportBtnClicked = false
      }
      // AK: To know which tab is clicked
      this.currentSelectedTab = parseInt(value)
      if (this.currentSelectedTab === 1) {
        this.csvFileName = 'DeepDiveParticipantReport'
        this.sortColumnNames = ['Participant', 'VideosWatched', 'TotalVideos', 'AvgDeepDiveViews']
        this.columnAlias = ['Participant', 'Videos Watched', 'Total Videos', '% Views']
        this.columnRespKey = ['Participant', 'VideosWatched', 'TotalVideos', 'AvgDeepDiveViews']
      } else {
        this.csvFileName = 'DeepDiveViewsReport'
        this.sortColumnNames = ['VideoTitle', 'ParentTitle', 'TotalViews']
        this.columnAlias = ['Video Title', 'Parent Title', 'Total Views']
        this.columnRespKey = ['VideoTitle', 'ParentTitle', 'TotalViews']
      }
    },
    setGroupCourseObj (value) {
      // AK: When user selected particular group object then update it in parent file too
      this.selectedGroupCourseObj = value
    },
    setCohortObj (value) {
      // AK: When user selected particular cohort object then update it in parent file too
      this.selectedCohortObj = value
    },
    updateViewBtnClickedFlag (value) {
      this.isViewBtnClicked = value
      if (value) {
        this.bindColumnsNameAndAlias()
        if (this.currentSelectedTab === 1) {
          this.getDeepDiveParticipantReport()
        } else {
          this.getDeepDiveViewsReport()
        }
      }
    },
    exportCSV (value) {
      this.isExportBtnClicked = value
      if (value) {
        this.bindColumnsNameAndAlias()
        if (this.currentSelectedTab === 1) {
          this.getDeepDiveParticipantReport()
        } else {
          this.getDeepDiveViewsReport()
        }
      }
    },
    bindColumnsNameAndAlias: function () {
      this.columnNameToShow = []
      for (var i = 0; i < this.columnRespKey.length; i++) {
        var obj = {
          ColumnName: this.columnRespKey[i],
          ColumnAlias: this.columnAlias[i]
        }
        this.columnNameToShow.push(obj)
      }
      // console.log('Column And alias Name Obj >>>> ' + JSON.stringify(this.columnNameToShow))
    },
    getDeepDiveParticipantReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj.CohortId !== null || this.selectedCohortObj.CohortId !== undefined || this.selectedCohortObj.CohortId !== '') {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getDeepDiveParticipantData(storeObj.state.access_token, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              this.$store.state.isLoading = false
              _this.deepDiveRespArr = responseObj.data.ParticipantDataList
              // console.log(JSON.stringify(_this.deepDiveRespArr))
              if (parseInt(_this.deepDiveRespArr.length) === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showDeepDiveList = false
              } else {
                this.processAndExecuteSelectedOperation()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('COHORT ID is NULL hence declined LOADING Deep Dive Participant LIST')
      }
    },
    processAndExecuteSelectedOperation: function () {
      if ((!this.isExportBtnClicked) && this.isViewBtnClicked) {
        // AK: If export btn not clicked and list is shown previously then show list only
        this.showDeepDiveList = true
      } else if (this.isExportBtnClicked && (!this.isViewBtnClicked)) {
        // AK: If user directly clicked on export button without clicking view first then export data
        this.exportData()
      } else if (this.isExportBtnClicked && this.isViewBtnClicked) {
        // AK: If user performed both operations then performed both operations
        this.showDeepDiveList = true
        this.exportData()
      }
    },
    exportData: function () {
      return csvHelper.export(this.getDeepDiveRespArrResp, this.columnRespKey, this.columnAlias, this.csvFileName + '(' + this.selectedCohortObj.CohortName + ')')
    },
    getDeepDiveViewsReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj.CohortId !== null || this.selectedCohortObj.CohortId !== undefined || this.selectedCohortObj.CohortId !== '') {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getDeepDiveViewsData(storeObj.state.access_token, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.deepDiveRespArr = responseObj.data.ViewsDataList
              // console.log(JSON.stringify('getDeepDiveViewsReport >>>> ' + JSON.stringify(_this.deepDiveRespArr)))
              if (parseInt(_this.deepDiveRespArr.length) === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showDeepDiveList = false
              } else {
                this.processAndExecuteSelectedOperation()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('COHORT ID is NULL hence declined LOADING Deep Dive Participant LIST')
      }
    }
  },
  computed: {
    getDeepDiveRespArrResp: {
      get: function () {
        return this.deepDiveRespArr
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  watch: {
    currentSelectedTab: function () {
      this.bindColumnsNameAndAlias()
      if (this.currentSelectedTab === 1) {
        this.csvFileName = 'DeepDiveParticipantReport'
        this.getDeepDiveParticipantReport()
      } else {
        this.csvFileName = 'DeepDiveViewsReport'
        this.getDeepDiveViewsReport()
      }
    }
  },
  name: 'deep-dive-report'
}
</script>

<style scoped>
.deep-dive-report {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
/* Using Only for footer */
.footer{
    /* position: fixed; */
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.margin-left-1point5Perc{
  margin-left:1.5% !important;
}
.margin-right-1point5Perc{
  margin-right:1.5% !important;
}
.width-97Point4{
  width:97.4% !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/DeepDive.vue